import {CacheKeyConfig, useGrpcRequest} from '@aboutyou/data-fetcher';
import {CouponLandingPageService_GetGenderSwitchLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/service.grpc.lazy';
import {useParams} from '@aboutyou/router';
import {useFullSession} from '@aboutyou/user';
import {useAppliedPotentialFilters} from '../../../../features/ProductStream/utils/useAppliedPotentialFilters';
import {useReductionsStateRequestParameter} from '../../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../../shared-deprecated/useTargetGroupIdentifier';
import {useCategoryIdentifier} from '../../hooks/useCategoryIdentifier';

export const useStreamGenderSwitchRequest = () => {
  const filters = useAppliedPotentialFilters();
  const fullSession = useFullSession();
  const {promotionId} = useParams();
  const targetGroup = useTargetGroupIdentifier();
  const categoryIdentifier = useCategoryIdentifier();

  return useGrpcRequest(
    CouponLandingPageService_GetGenderSwitchLazy,
    {
      session: fullSession!,
      appliedFilters: {
        filters,
        quickFilter: {},
      },
      targetGroup,
      couponPromotionId: promotionId!,
      reductionsState: useReductionsStateRequestParameter(),
      category: categoryIdentifier,
    },
    {
      // the gender filter should be refetched each time the user navigates through categories or subcategories.
      transformCacheKey: (config: CacheKeyConfig) => {
        return {
          ...config,
          params: {
            ...config.params,
            basketToken: undefined,
          },
        };
      },
      nonEssential: true,
      disabled: !fullSession,
      keepPreviousData: true,
    },
  );
};
